import { render, staticRenderFns } from "./render-date-column-value.vue?vue&type=template&id=b7ec8e64"
import script from "./render-date-column-value.vue?vue&type=script&lang=js"
export * from "./render-date-column-value.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/samuelscn/Área de Trabalho/veins/veins-api/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b7ec8e64')) {
      api.createRecord('b7ec8e64', component.options)
    } else {
      api.reload('b7ec8e64', component.options)
    }
    module.hot.accept("./render-date-column-value.vue?vue&type=template&id=b7ec8e64", function () {
      api.rerender('b7ec8e64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/ui/render/render-date-column-value.vue"
export default component.exports